import React from 'react';
import cx from 'classnames';
import { Select } from '../Select/index.js';
import styles from './index.module.scss.js';
import { ThumbV2 } from '../../ui/popups/Popup/ThumbV2/index.js';

const SelectV2 = ({
  options,
  onSelect,
  formType = true,
  selectedIds = [],
  popupWidth = "191px",
  thumbLabel = "Sort by:",
  image,
  className,
  style,
  layoutStyle,
  iconForMobile,
  searchPlaceholder = "Search currencies",
  isCenter,
  ...props
}) => /* @__PURE__ */ React.createElement("div", { ...props, className: cx(styles.box, className), style }, /* @__PURE__ */ React.createElement(
  Select,
  {
    ...props,
    options,
    isCenter,
    popupStyle: { width: popupWidth },
    renderThumb: (thumbProps) => /* @__PURE__ */ React.createElement(
      ThumbV2,
      {
        ...thumbProps,
        formType,
        roundIcon: true,
        image: thumbProps.image || image,
        thumbLabel,
        iconForMobile
      }
    ),
    popupGap: 16,
    popupClassName: "sort-dropdown-popup",
    searchPlaceholder,
    onSelect,
    selectedIds,
    horizontalAlignment: "auto",
    isMultiple: false,
    style: layoutStyle
  }
));
SelectV2.displayName = "SelectV2";

export { SelectV2 };
//# sourceMappingURL=index.js.map
